import React, { Component } from 'react';
import ProvisionConfigTable from './ProvisionConfigTable';
import ProvisionConfigEditPanel from './ProvisionConfigEditPanel';
import ProvisionConfigDetailsPanel from './ProvisionConfigDetailsPanel';
import { IFileProvisionConfig } from './types';
import { getAllProvisionerConfigsService } from './services';

interface IProps {
    // Define your props here if needed
}

export interface IFileProvisionerState {
    selectedConfig: IFileProvisionConfig | null;
    isEditPanelOpen: boolean;
    isDetailsPanelOpen: boolean;
    configs: IFileProvisionConfig[];
}

class FileProvisioner extends Component<IProps, IFileProvisionerState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            selectedConfig: null,
            isEditPanelOpen: false,
            isDetailsPanelOpen: false,
            configs: []
        };
    }

     async componentDidMount() {
        await this.loadConfigs();
    }

    private loadConfigs = async (): Promise<void> => {
        try {
            const configs = await getAllProvisionerConfigsService();
            if (configs && configs.length > 0) {
                this.setState({ configs});
            }
        } catch (error) {
            console.error('Failed to load configs:', error);
        }
    };

    private _onEditConfig = (config: IFileProvisionConfig): void => {
        this.setState({
            selectedConfig: config,
            isEditPanelOpen: true,
            isDetailsPanelOpen: false
        });
    };

    private _onViewDetails = (config: IFileProvisionConfig): void => {
        this.setState({
            selectedConfig: config,
            isDetailsPanelOpen: true,
            isEditPanelOpen: false
        });
    };

    private _onDismissEditPanel = (): void => {
        this.setState({
            isEditPanelOpen: false,
            selectedConfig: null
        });
    };

    private _onDismissDetailsPanel = (): void => {
        this.setState({
            isDetailsPanelOpen: false
        });
    };

    private _onSaveConfig = (config: IFileProvisionConfig): void => {
        const { configs } = this.state;

        if (configs.findIndex(f => f.id === config.id) === -1) {
            this.setState({
                configs: [...configs, config],
                isEditPanelOpen: false,
                selectedConfig: null
            });
        } else {
            // Update existing config
            const updatedConfigs = configs.map(c =>
                c.id === config.id ? config : c
            );
            this.setState({
                configs: updatedConfigs,
                isEditPanelOpen: false,
                selectedConfig: null
            });
        }
    };

    private _onEditFromDetails = (config: IFileProvisionConfig): void => {
        this.setState({
            selectedConfig: config,
            isDetailsPanelOpen: false,
            isEditPanelOpen: true
        });
    };

    setStateProperty = (propertyName: keyof IFileProvisionerState, value: any) => {
        this.setState({ [propertyName]: value } as Pick<IFileProvisionerState, keyof IFileProvisionerState>);
    }

    render() {
        const { selectedConfig, isEditPanelOpen, isDetailsPanelOpen } = this.state;

        return (
            <div style={{ padding: '20px' }}>
                <ProvisionConfigTable
                    onEditConfig={this._onEditConfig}
                    onViewDetails={this._onViewDetails}
                    onSetState={this.setStateProperty}
                    configs = {this.state.configs}
                />

                <ProvisionConfigEditPanel
                    isOpen={isEditPanelOpen}
                    config={selectedConfig}
                    onDismiss={this._onDismissEditPanel}
                    onSave={this._onSaveConfig}
                />

                <ProvisionConfigDetailsPanel
                    isOpen={isDetailsPanelOpen}
                    config={selectedConfig}
                    onDismiss={this._onDismissDetailsPanel}
                    onEdit={this._onEditFromDetails}
                />
            </div>
        );
    }
}

export default FileProvisioner;